import * as React from "react";
const ProfileIcon = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.9998 13.3333C18.9454 13.3333 21.3332 10.9455 21.3332 8.00001C21.3332 5.05449 18.9454 2.66667 15.9998 2.66667C13.0543 2.66667 10.6665 5.05449 10.6665 8.00001C10.6665 10.9455 13.0543 13.3333 15.9998 13.3333Z"
      fill="#016FFC"
    />
    <path
      opacity={0.5}
      d="M26.6668 23.3333C26.6668 26.6467 26.6668 29.3333 16.0002 29.3333C5.3335 29.3333 5.3335 26.6467 5.3335 23.3333C5.3335 20.02 10.1095 17.3333 16.0002 17.3333C21.8908 17.3333 26.6668 20.02 26.6668 23.3333Z"
      fill="#016FFC"
    />

  </svg>
);

export default ProfileIcon;
